
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTrophy as ObiTrophyElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-trophy.js';
 
 
 

 
 export const ObiTrophy = createComponent({
   react: React,
   tagName: 'obi-trophy',
   elementClass: ObiTrophyElement,
   events: {
     
   }
  });
 
 